import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./ManageRequest.css";
import {
  postAcceptedDoctorRequest,
  putRefusedDoctorRequest,
} from "../../../../../service-layer/MedicalStaffService";
import { sendEmail } from "../../../../../service-layer/EmailService"; // Import the CSS file for styling
import { useTranslation } from "react-i18next";
import { CButton } from "@coreui/react";
import LogoutModal from "../../../../components/logout-moal/LogoutModal";

const ManageRequest = ({ requestId, requestData }) => {
  const { t } = useTranslation();
  const [state, setState] = useState({ status: null, clicked: false });
  const [open, setOpen] = useState(false);
  const [tag, setTag] = useState(null);

  const handleAcceptRequest = () => {
    setTag("accept");
    setOpen(true);
  };

  const handleRejectRequest = () => {
    setOpen(true);
    setTag("reject");
  };

  const handleClose = () => setOpen(false);

  const manageRequest = () => {
    setState({ status: tag, clicked: true });
    if (tag === "accept") {
      console.log("request accepted " + requestId);
      console.log(requestData);
      const currentTimestamp = new Date().toISOString();
      const currentDate = new Date();
      const next20YearDate = new Date(
        currentDate.setFullYear(currentDate.getFullYear() + 20),
      );
      const next20YearTimestamp = next20YearDate.toISOString();

      console.log(currentTimestamp);
      console.log(next20YearTimestamp);
      const acceptedRequest = {
        medicalStaffRequestId: requestId,
        name: requestData.name,
        surname: requestData.surname,
        fiscalCode: requestData.fiscalCode,
        specialization: requestData.specialization,
        registrationNumber: requestData.registrationNumber,
        email: requestData.email,
        validFrom: currentTimestamp,
        staffTypeId: 2,
      };
      postAcceptedDoctorRequest(acceptedRequest).then((r) => console.log("request accepted" + r));
      sendEmail(
        requestData.email,
        t("requestAcceptedSubject"),
        t("requestAcceptedBody"),
      ).then((r) => console.log(r));
    } else {
      console.log("request rejected " + requestId);
      putRefusedDoctorRequest(requestId).then((r) => console.log(r));
      sendEmail(
        requestData.email,
        t("requestRejectedSubject"),
        t("requestRejectedBody"),
      ).then((r) => console.log(r));
    }
    setOpen(false);
  };

  return (
    <div className="manage-request-button-container">
      {state.status === null && (
        <div className="center-div-content">
          <CButton
            className="accept-request-button"
            onClick={() => handleAcceptRequest()}
          >
            {t("accept")}
          </CButton>

          <CButton
            className="reject-request-button"
            onClick={() => handleRejectRequest()}
          >
            {t("reject")}
          </CButton>

          {tag === "accept" && (
            <LogoutModal
              show={open}
              handleConfirm={() => manageRequest()}
              handleClose={handleClose}
              title={t("acceptRequest")}
              message={t("confirmAccept")}
              tag={"acceptRequest"}
            />
          )}

          {tag === "reject" && (
            <LogoutModal
              show={open}
              handleConfirm={() => manageRequest()}
              handleClose={handleClose}
              title={t("rejectRequest")}
              message={t("confirmReject")}
              tag={"rejectRequest"}
            />
          )}
        </div>
      )}
      {state.status === "accept" && (
        <>
          <CButton
            variant="outlined"
            color="#204770"
            disabled
            className="disactivate-doctor-button-expanded"
          >
            {t("accepted")}
          </CButton>
        </>
      )}
      {state.status === "reject" && (
        <CButton
          variant="outlined"
          color="error"
          disabled
          className="disactivate-doctor-button-expanded"
        >
          {t("rejected")}
        </CButton>
      )}
    </div>
  );
};

ManageRequest.propTypes = {
  requestId: PropTypes.number.isRequired,
  requestData: PropTypes.object.isRequired,
};

export default ManageRequest;
